import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dialog-alert-confirm',
  templateUrl: './dialog-alert-confirm.component.html',
  styleUrls: ['./dialog-alert-confirm.component.scss'],
})
export class DialogAlertConfirmComponent implements OnInit {

  title:string = "";
  message:string = "";
  constructor(@Inject(MAT_DIALOG_DATA) private data: { title: string, message:string }) {
    this.title = data.title;
    this.message = data.message
  }

  ngOnInit() {}

}
